import * as React from 'react';
const Titles = React.memo((props: {
  value: string;
}) => <div aria-label="Title" className="flex justify-left leading-tight overflow-auto pt-[5px]">
    {props.value || '--'}
  </div>);
Titles.displayName = 'Titles';
export default Titles;